import { UPDATE_LAST_TORCH } from "./lastTorchGeolocationReducer"

export const updateLastTorch = (obj) => ({
    type: UPDATE_LAST_TORCH,
    payload: obj
})